import { Component, OnInit, OnDestroy, OnChanges, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';

@Component({
    selector: 'ai-lead-entry-tab',
    templateUrl: './aiLeadEntry.component.html',
})
export class AiLeadEntryComponent implements OnInit, OnDestroy, OnChanges {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input('params') params: string;

    loading = false;
    triggerLoading = false;
    cronResult: any = null;

    leadForm: any = {
        name: '',
        phone: '',
        email: '',
        message: '',
        source: 'Facebook',
        meta: {
            lead_id: '',
            status: 'ACTIVE',
            created_time: '',
            page_name: '',
            page_id: '',
            form_id: '',
            form_name: '',
            campaign: {
                campaign_id: '',
                campaign_name: '',
                adset_id: '',
                adset_name: ''
            },
            ad: {
                ad_id: '',
                ad_name: '',
                platform: 'Facebook'
            }
        }
    };

    result: any = null;
    triggerLog: any[] = [];
    loadingLog = false;

    constructor(
        private http: HttpClient,
        private toasterService: ToasterService
    ) {}

    ngOnInit() {
        this.loadTriggerLog();
    }

    ngOnDestroy() {}

    ngOnChanges() {
        if (this.active) {
            this.loadTriggerLog();
        }
    }

    submitLead() {
        if (!this.leadForm.phone || !this.leadForm.name) {
            this.toasterService.pop('error', 'Error', 'Name and Phone are required');
            return;
        }

        this.loading = true;
        this.result = null;

        const mobileNumber = this.leadForm.phone.trim().replace(/[^0-9]/g, '').slice(-10);

        this.http.get(`/api/common/clientSearchGridList?search=${mobileNumber}&start=0&limit=10&orderColumn=client_id&orderDir=desc&title=Phone%20Tracking`)
            .subscribe((searchRes: any) => {
                const allResults = searchRes.data || [];
                const matched = allResults.filter((c: any) => {
                    const parts = (c.mobile || '').split('/').map((m: string) => m.trim()).filter(Boolean);
                    return parts.includes(mobileNumber);
                });

                if (matched.length === 0) {
                    this.createClientAndWalkIn(mobileNumber);
                } else {
                    const client = matched[0];
                    this.addWalkIn(client.client_id, client.client_name, mobileNumber, 'EXISTING');
                }
            }, err => {
                this.loading = false;
                this.toasterService.pop('error', 'Error', 'Failed to search client');
            });
    }

    private createClientAndWalkIn(mobileNumber: string) {
        const namePart = this.leadForm.name.replace(/\s/g, '').slice(-4).toUpperCase();
        const phonePart = mobileNumber.slice(-4);
        const clientNo = namePart + phonePart;

        const clientPayload = {
            mode: 'Add',
            client_no: clientNo,
            client_name: this.leadForm.name,
            mobile: mobileNumber,
            ref_id: 1832,
            reg_branch: 4,
            reference1: this.leadForm.source,
            meta: this.leadForm.meta
        };

        this.http.post('/api/client/addUpdateClient', clientPayload)
            .subscribe((res: any) => {
                if (res && res.success && res.client_id) {
                    this.addWalkIn(res.client_id, this.leadForm.name, mobileNumber, 'NEW');
                } else if (!res.success && res.client_id) {
                    this.addWalkIn(res.client_id, res.client_name || this.leadForm.name, mobileNumber, 'EXISTING');
                } else {
                    this.loading = false;
                    this.result = { success: false, message: res.message || 'Failed to create client', action: 'CREATE_CLIENT' };
                    this.toasterService.pop('error', 'Error', this.result.message);
                }
            }, err => {
                this.loading = false;
                this.toasterService.pop('error', 'Error', 'Failed to create client');
            });
    }

    private addWalkIn(clientId: any, clientName: string, mobileNumber: string, action: string) {
        const today = new Date().toISOString().split('T')[0];

        const walkInPayload = {
            client_id: parseInt(clientId),
            client_name: clientName,
            date: today,
            mode: 'Add',
            page_type: 'Phone Tracking',
            followup_status: 9,
            description: `Lead - ${this.leadForm.message}`,
            reference: 1832,
            ref_name: 'FB LEADS',
            remarks_by: 162,
            source_id: 3,
            source_name: 'LEADS',
            call_by: 'DEEPA',
            call_number: '7339409914',
            assign_empid: 102,
            hasEditDisabled: false,
            meta: this.leadForm.meta
        };

        this.http.post('/api/clientWalkIn/addUpdateWalkIn', walkInPayload)
            .subscribe((res: any) => {
                this.loading = false;
                this.result = {
                    success: res.success,
                    message: res.message,
                    action: action,
                    client_id: clientId,
                    client_name: clientName,
                    mobile: mobileNumber
                };
                if (res.success) {
                    this.toasterService.pop('success', 'Success', `Lead saved & AI call triggered (${action === 'NEW' ? 'New Client' : 'Existing Client'})`);
                    this.resetForm();
                    this.loadTriggerLog();
                } else {
                    this.toasterService.pop('error', 'Error', res.message);
                }
            }, err => {
                this.loading = false;
                this.toasterService.pop('error', 'Error', 'Failed to add walk-in');
            });
    }

    loadTriggerLog() {
        this.loadingLog = true;
        this.http.get('/api/aiCallWebhook/getTriggerLog')
            .subscribe((res: any) => {
                this.loadingLog = false;
                this.triggerLog = res.data || [];
            }, () => {
                this.loadingLog = false;
            });
    }

    runCronTrigger() {
        this.triggerLoading = true;
        this.cronResult = null;
        this.http.get('/api/aiCallWebhook/processCronTrigger')
            .subscribe((res: any) => {
                this.triggerLoading = false;
                this.cronResult = res;
                if (res.status === 'success') {
                    this.toasterService.pop('success', 'Done', `Triggered: ${res.triggered} call(s)`);
                    this.loadTriggerLog();
                } else if (res.status === 'skipped') {
                    this.toasterService.pop('warning', 'Skipped', res.message);
                } else {
                    this.toasterService.pop('error', 'Error', res.message || 'Trigger failed');
                }
            }, () => {
                this.triggerLoading = false;
                this.toasterService.pop('error', 'Error', 'Failed to run call trigger');
            });
    }

    resetForm() {
        this.leadForm = {
            name: '',
            phone: '',
            email: '',
            message: '',
            source: 'Facebook',
            meta: {
                lead_id: '',
                status: 'ACTIVE',
                created_time: '',
                page_name: '',
                page_id: '',
                form_id: '',
                form_name: '',
                campaign: { campaign_id: '', campaign_name: '', adset_id: '', adset_name: '' },
                ad: { ad_id: '', ad_name: '', platform: 'Facebook' }
            }
        };
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/dataCorrection/aiLeadEntry/aiLeadEntry.component.ts